import { useContext } from "react";

import { CloudFileAssociationContext } from "./CloudFileAssociationContext";

export const useCloudFileAssociationSection = (): CloudFileAssociationContext =>
    useContext(CloudFileAssociationContext);
